// extracted by mini-css-extract-plugin
module.exports = {"pointsColumnValue":"styles_pointsColumnValue__yx1nW","label-product-redemption":"styles_label-product-redemption__1f8ez"};